import { useEffect, useState } from 'react'
import { ErroreApi } from '../servizi/api.ts'
import {
  computerRicordatoQui, nomeVerifica, sblocca, sfidaComputer, suComputer, type OpzioniSblocco,
} from '../servizi/accesso-ricordato.ts'
import { useSessione } from '../servizi/sessione.tsx'
import { Avviso } from './Pezzi.tsx'
import { Bottone } from './base.tsx'

/** La sfida vale cinque minuti sul server: oltre quattro se ne chiede un'altra prima di aprire Windows Hello. */
const VALIDITA_SFIDA = 4 * 60_000

/**
 * «Entra con Windows Hello» o «con Touch ID» nella pagina di accesso di un computer ricordato (531): a
 * sessione scaduta, dopo «Esci» o dopo le dodici ore. La sfida arriva prima del clic, perche' il clic porti
 * dritto alla verifica; il nome dice di chi e' il computer, cosi' un collega capisce che quella strada non
 * e' per lui. Nome utente e password restano sotto, come sempre.
 *
 * Compare solo dove il browser ha il segnale del computer ricordato (servizi/accesso-ricordato.ts): le
 * altre pagine di accesso non chiedono niente al server.
 */
export function EntraConComputer() {
  const { aggiorna } = useSessione()
  const [sfida, setSfida] = useState<{ opzioni: OpzioniSblocco; nome: string; dal: number } | null>(null)
  const [errore, setErrore] = useState<string | null>(null)
  const [inCorso, setInCorso] = useState(false)
  const attivo = suComputer() && computerRicordatoQui()

  const chiedi = async () => {
    const s = await sfidaComputer().catch(() => null)
    setSfida(s ? { ...s, dal: Date.now() } : null)
    return s
  }
  useEffect(() => { if (attivo) void chiedi() }, [attivo])

  async function entra() {
    if (!sfida) return
    setErrore(null); setInCorso(true)
    try {
      let opzioni = sfida.opzioni
      if (Date.now() - sfida.dal > VALIDITA_SFIDA) {
        const nuova = await chiedi()
        if (!nuova) return
        opzioni = nuova.opzioni
      }
      await sblocca(opzioni)
      await aggiorna()
    } catch (e) {
      setErrore(e instanceof ErroreApi ? e.message
        : `${nomeVerifica().replace(/^./, (c) => c.toUpperCase())} non ha confermato: riprova, oppure entra con `
          + 'nome utente e password.')
      // La sfida vale una volta: se ne prepara un'altra per il prossimo clic.
      void chiedi()
    } finally {
      setInCorso(false)
    }
  }

  if (!attivo || !sfida) return null
  return (
    <div className="accesso-computer">
      {errore && <Avviso tipo="errore">{errore}</Avviso>}
      <Bottone variante="primario" larghezzaPiena inCorso={inCorso} onClick={() => { void entra() }}>
        Entra con {nomeVerifica()}
      </Bottone>
      <p className="accesso-computer-nota">
        Questo computer è ricordato per <strong>{sfida.nome}</strong>. Se non sei tu, entra con nome utente e
        password.
      </p>
      <div className="accesso-computer-oppure" aria-hidden="true"><span>oppure</span></div>
    </div>
  )
}
